"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoogleToken = exports.SpreadsheetContextProvider = void 0;
const react_1 = __importStar(require("react"));
const google_1 = require("@react-oauth/google");
const ENV_CLIENT_ID = process.env["REACT_APP_GOOGLE_CLIENT_ID"];
function canUseGoogleClientId(clientId) {
    return !!clientId;
}
const GoogleAuthContext = (0, react_1.createContext)({
    clientIdAvailable: false,
    credential: null,
});
const deadHandlers = new Proxy({}, {
    get: () => () => {
        throw new Error("GoogleAuth Update Handler has been called out of context");
    },
});
const GoogleAuthUpdateHandlerContext = (0, react_1.createContext)(deadHandlers);
const SpreadsheetContextProvider = ({ children }) => {
    const clientIdAvailable = canUseGoogleClientId(ENV_CLIENT_ID);
    const [state, setState] = (0, react_1.useState)({
        clientIdAvailable,
        credential: null,
    });
    (0, react_1.useEffect)(() => {
        console.log(state);
    }, [state]);
    const handlers = (0, react_1.useMemo)(() => clientIdAvailable
        ? {
            onSignInSuccess: (cred) => setState((cur) => (Object.assign(Object.assign({}, cur), { clientIdAvailable, credential: cred }))),
            onSignInError: () => setState((cur) => (Object.assign(Object.assign({}, cur), { clientIdAvailable, credential: null }))),
            signOut: () => {
                console.log("GoogleLogout");
                (0, google_1.googleLogout)();
            },
        }
        : deadHandlers, [clientIdAvailable]);
    return (react_1.default.createElement(GoogleAuthContext.Provider, { value: state },
        react_1.default.createElement(GoogleAuthUpdateHandlerContext.Provider, { value: handlers }, clientIdAvailable ? (react_1.default.createElement(google_1.GoogleOAuthProvider, { clientId: ENV_CLIENT_ID }, children)) : (children))));
};
exports.SpreadsheetContextProvider = SpreadsheetContextProvider;
function useGoogleToken() {
    const { onSignInSuccess, onSignInError } = (0, react_1.useContext)(GoogleAuthUpdateHandlerContext);
    const state = (0, react_1.useContext)(GoogleAuthContext);
    const promiseRef = (0, react_1.useRef)({});
    const login = (0, google_1.useGoogleLogin)({
        onSuccess: (0, react_1.useCallback)((cred) => {
            var _a, _b;
            (_b = (_a = promiseRef.current).resolve) === null || _b === void 0 ? void 0 : _b.call(_a, cred.access_token);
            onSignInSuccess(cred);
        }, [onSignInSuccess]),
        onError: (0, react_1.useCallback)((err) => {
            var _a, _b;
            (_b = (_a = promiseRef.current).reject) === null || _b === void 0 ? void 0 : _b.call(_a, err);
            onSignInError();
        }, [onSignInError]),
        scope: "email profile openid https://www.googleapis.com/auth/spreadsheets",
        flow: "implicit",
    });
    (0, react_1.useEffect)(() => {
        promiseRef.current.promise = new Promise((resolve, reject) => {
            promiseRef.current.resolve = resolve;
            promiseRef.current.reject = reject;
        });
    }, []);
    return () => __awaiter(this, void 0, void 0, function* () {
        if (state.credential)
            return state.credential.access_token;
        // TODO: 2024/3/20 Shōsei Yū <4kizuki@h4dz.io>
        //  We should move this promise handling into somewhere else such as Context Provider.
        if (promiseRef.current.promise === undefined)
            return;
        login();
        return yield promiseRef.current.promise;
    });
}
exports.useGoogleToken = useGoogleToken;
